import { render } from "./Calendar.vue?vue&type=template&id=08850332"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=08850332&lang=css"
script.render = render

export default script